import React from 'react';
import { labelFor } from './labelFor';
import { Range, MeterRange } from '@ui';

export interface MeterScoreDemoChildProps {
  value: number;
  setValue: React.Dispatch<React.SetStateAction<number>>;
}

export const MeterScoreFullDemo: React.FC<MeterScoreDemoChildProps> = ({ value, setValue }) => {
  const label = labelFor(value);
  const handleChange = (value: number) => {
    setValue(value);
  };
  return (
    <>
      <div className='row'>
        <div className='row'>
          <label className='hint' htmlFor='scoreRange'>
            Score
          </label>
          <Range id='scoreRange' value={value} min={0} max={100} step={1} onChange={handleChange} />
        </div>
        <span className='badge' id='scoreBadge'>
          {value} • {label}
        </span>
      </div>

      <MeterRange
        value={value}
        max={100}
        className='mt-12'
        ariaLabel={`Score ${value} of 100`}
        hint='0–49: Poor • 50–74: Fair • 75–89: Good • 90–100: Excellent'
      />
    </>
  );
};
